export default __webpack_public_path__ + "static/media/no-data-placeholder.da652d0a.svg";